import { Link } from "react-router-dom";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../image/Image";
import Iconify from "../../FinalForms/ui/iconify/Iconify";

export const renderGridAction = (rowData, col, rowIndex, onActionHandler, isIcon) => {
  if (!col.defaultAction) {
    col.defaultAction = {
      allowEdit: true,
      allowDelete: true,
    };
  }

  const handleAction = (actionName, data, rowIndex) => {
    if (onActionHandler) {
      if (onActionHandler[actionName]) {
        onActionHandler[actionName](data);
      }
    }
    // if (col.actionHandler) {
    //   if (actionName === "EDIT" && onActionHandler && onActionHandler["EDIT"]) {

    //     onActionHandler["EDIT"](data);

    //   } else if (actionName === "DELETE" && col.actionHandler.onDeleteAction) {
    //     col.actionHandler.onDeleteAction(data);
    //   }
    // }
  };

  return (
    <div className="d-flex action-button">
      {col.customAction &&
        col.customAction.length > 0 &&
        col.customAction.map((action, index) => {
          if (action.name === "REJECTED_REASON" && rowData?.status?.toLowerCase() !== "rejected") {
            return null;
          }
          return (
            <Link
              key={`customAction_${index}`}
              onClick={(e) => {
                e.preventDefault();
                handleAction(action.name, rowData);
              }}
              className="mr-4"
              title={action.name}
              href
            >
              {action.isIcon ? (
                <Iconify icon={action.iconName} />
              ) : (
                <Image imagePath={action.iconName} altText={action.name} />
              )}
            </Link>
          )
        })}
      {col.defaultAction.allowEdit && (
        <Link
          onClick={(e) => {
            e.preventDefault();
            handleAction("EDIT", rowData);
          }}
          className="mr-4"
          title="EDIT"
        >
          <Iconify icon="lucide:edit" />
        </Link>
      )}

      {col.defaultAction.allowDelete && (
        <Link
          onClick={(e) => {
            e.preventDefault();
            handleAction("DELETE", rowData);
          }}
          className="mr-4"
          title="DELETE"
        >
          <Iconify icon="uiw:delete" />
        </Link>
      )}
    </div>
  );
};
